export default (link: string) => {
  if (link.startsWith("http://") || link.startsWith("https://")) {
    return link;
  }

  return `//${link}`;
};
